import React, { useEffect } from "react";
import { useAuthContext } from '../contexts/AuthContext'; // Caminho relativo correto


const SessionWarning = () => {
  const { timeLeft, isWarning } = useAuthContext();

  useEffect(() => {
    if (isWarning) {
      console.warn(`[SessionWarning] Faltam ${timeLeft} segundos para expirar.`);
    }
  }, [isWarning, timeLeft]);

  if (!isWarning || !timeLeft || timeLeft <= 0) return null; // Garantir que só renderize em casos válidos

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        backgroundColor: "#fdf2e9",
        color: "#d35400",
        padding: "20px",
        borderRadius: "12px",
        zIndex: 1000,
        boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.15)",
        display: "flex",
        alignItems: "center",
        fontFamily: "'Arial', sans-serif",
        fontSize: "16px",
        lineHeight: "1.5",
      }}
    >
      <span
        style={{
          fontSize: "24px",
          marginRight: "15px",
        }}
      >
        ⚠️
      </span>
      <div>
        <p style={{ margin: "0 0 5px" }}>
          <strong>Atenção!</strong> Sua sessão expira em{" "}
          <strong>{timeLeft} segundos</strong>.
        </p>
        <p style={{ margin: 0 }}>
          Salve suas alterações para evitar perda de dados.
        </p>
      </div>
    </div>
  );
  
};

export default SessionWarning;
